class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.recommendSearchResults = this.querySelector('#recommend-search');
    this.predictiveSearchNoResults = this.querySelector('.predictive-search-no-results');
    this.close();
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }
  init() {
    this.input.addEventListener('focus',() => {
      const searchTerm = this.input.value.trim();
      if(!Boolean(searchTerm)){
        this.recommendSearchResults.style.display = 'block'
      }
    })
    this.input.addEventListener('blur', () => {
      const searchTerm = this.input.value.trim();
      if(!Boolean(searchTerm)){
        this.recommendSearchResults.style.display = 'none'
      }
    });
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      this.predictiveSearchNoResults.style.display = 'none'
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        if(!resultsMarkup){
          this.close() 
          this.predictiveSearchNoResults.style.display = 'block'
          this.predictiveSearchNoResults.innerHTML = '<span>No results found for “'+  this.input.value +'”</span>'
          return
        } 
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.input.focus()
    this.recommendSearchResults.style.display = 'none';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.recommendSearchResults.style.display = 'block';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);